import { AuthUser } from '@/modules/auth/models/AuthUser';
import { getters } from '/@/modules/core/app/helpers/store';
import { PaidPlanRouteConfig } from '@/modules/core/app/helpers/PaidPlanRouteConfig';

export class MeetingRouteConfig extends PaidPlanRouteConfig {
  canAccessRoute(): boolean {
    const authUser: AuthUser | null = getters.auth.getUser();

    if (authUser?.currentEstate?.isUnPaidSelfServePlan) {
      return authUser.currentEstate.isBasicPlan;
    }

    return !!authUser?.permission?.canAccessMeetings && super.canAccessRoute();
  }
}
